import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-status',
    templateUrl: './app-status.component.html',
    styleUrls: ['./app-status.component.css'],
    standalone: false
})
export class AppStatusComponent {
  @Input() type: 'success' | 'warning' | 'danger' = 'success';
  @Input() icon: boolean = true;
  @Input() clickable: boolean = false;
  @Output() onClick = new EventEmitter();
}
